import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "notfound",
    templateUrl: "./notfound.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class NotFoundComponent {

}
